import { CampaignActionPostItemController } from './campaign-action-post-item.controller'

function campaignActionPostItem () {
  return {
    scope: {
      post: '<',
      disabled: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-action-post-item/campaign-action-post-item.html?$$REVISION$$',
    controller: CampaignActionPostItemController
  }
}

export { campaignActionPostItem }
